<template lang="pug">
.send-document-category-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // display cells
    // セル：番号
    template(#cell(no)="row")
      span {{ row.item.id }}
    // セル：使用
    template(#cell(enabled)="row")
      span.used(v-if="row.item.enabled == true") 使用する
      span.unused(v-else) 使用しない

    // edit cells
    // セル：番号
    template(#cell(editNo)="row")
      span {{ row.item.id }}
    // セル：使用
    template(#cell(editEnabled)="row")
      EnableSwitch(v-model="row.item.enabled")
    // セル：カテゴリ名
    template(#cell(editName)="row")
      input.register-form(v-model="row.item.name" :name="'category-name-' + row.item.id" placeholder="文書種類" type="text"
        v-validate="{ required: true, max: 32 }" maxlength="32" data-vv-as="文書種類" :class="{ noinput: (!row.item.name) }")
      .error-messages(v-for="error in errors.collect('category-name-' + row.item.id)")
        label.error-message {{ error }}
    // セル：説明
    template(#cell(editDescription)="row")
      input.register-form(v-model="row.item.description" :name="'description-' + row.item.id" placeholder="説明" type="text"
        v-validate="{ max: 32 }" maxlength="32" data-vv-as="説明")
      .error-messages(v-for="error in errors.collect('description-' + row.item.id)")
        label.error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { SendDocumentCategoryGetModel } from "@/commons/services/SendDocumentCategories";

import EnableSwitch from "@/pc/basics/EnableSwitch.vue";

/**
 * ### 文書送付カテゴリーテーブルコンポーネント
 */
@Component({
  components: {
    EnableSwitch
  }
})
export default class CategoryTable extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<CategoryTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<CategoryTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<CategoryTableItem> {
    return this.value;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(item: CategoryTableItem): void {
    this.$emit("onEdit", item);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(item: CategoryTableItem): void {
    this.$emit("onDelete", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface CategoryTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface CategoryTableItem extends SendDocumentCategoryGetModel {}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

// 親要素からネストしてスタイルを指定する
.send-document-category-table-component {
  .register-form {
    width: 100%;
    display: block;
    height: 42px;
    padding: 6px 12px;
    font-size: 16px;
    background-image: none;
    background-color: $bg-default;
    border: 1px solid $form-border-color;
    border-radius: 0.25rem;
  }
  .noinput {
    background-color: $bg-require-input;
  }
  // 入力欄にフォーカスが当たった際は強調する
  input:focus {
    // chromeが自動的に付与するスタイルを無効化する
    outline: none;
    box-shadow: 0 0 0 0.2rem $form-boxshadow-select-color;
    border: 1px solid $form-border-select-color !important;
    border-radius: 0.25rem;
  }
}
</style>
